// @packages
import { StatusBar } from 'expo-status-bar';
import React from 'react';
import { View } from 'react-native';

// @scripts
import ChangePasswordForm from '../../components/organisms/change-password-form';
import useStyles from './styles';

const Login = () => {
  const styles = useStyles();

  return (
    <View style={styles.container}>
      <ChangePasswordForm />
      <StatusBar style="auto" />
    </View>
  );
};

export default Login;
